const isFraud = response => {
  const disabledSource = response.data?.disabledSource;
  return disabledSource === 'VMG-00203' || disabledSource === 'VMG-00205';
};

export default isFraud;
